import { useState } from 'react';

import Tabs from '@/components/Tab/Tabs';

import { BrandView } from './BrandView';
import { LineView } from './LineView';
import { OptionView } from './OptionView';
import { ProductView } from './ProductView';

const TabId = {
  PRODUCTS: 'products',
  BRANDS: 'brands',
  LINES: 'lines',
  PRODUCT_OPTIONS: 'product-options',
} as const;

type TabIdT = (typeof TabId)[keyof typeof TabId];

export const ProductManagerPage = () => {
  const [selectedTabId, setSelectedTabId] = useState<TabIdT | null>(
    TabId.PRODUCTS,
  );
  const tabs = [
    {
      id: TabId.PRODUCTS,
      text: 'Product',
      content: <ProductView />,
    },
    {
      id: TabId.BRANDS,
      text: 'Brand',
      content: <BrandView />,
    },
    {
      id: TabId.LINES,
      text: 'Line',
      content: <LineView />,
    },
    {
      id: TabId.PRODUCT_OPTIONS,
      text: 'Option',
      content: <OptionView />,
    },
  ];
  return (
    <div className="h-screen w-full overflow-auto">
      <div className="px-8 py-5 flex h-full flex-col overflow-auto">
        <Tabs tabs={tabs} selectedTabId={selectedTabId}>
          <Tabs.TabHeader onSelect={(id) => setSelectedTabId(id as TabIdT)} />
          <div className="pt-6 flex flex-col overflow-auto flex-1">
            <Tabs.TabBody className="flex flex-col flex-1 overflow-auto" />
          </div>
        </Tabs>
      </div>
    </div>
  );
};
